import { LazyImport, LazyModule } from 'owa-bundling';
export { default as TranslationSettings } from './store/schema/TranslationSettings';

const lazyModule = new LazyModule(() => import(/* webpackChunkName: "Translation"*/ './lazyIndex'));

export let lazyAddExcludedLanguage = new LazyImport(lazyModule, m => m.addExcludedLanguage);
export let lazyCheckCanTranslate = new LazyImport(lazyModule, m => m.checkCanTranslate);
export let lazyInitSupportedLanguages = new LazyImport(lazyModule, m => m.initSupportedLanguages);
export let lazyInitAndGetSupportedLanguageMap = new LazyImport(
    lazyModule,
    m => m.initAndGetSupportedLanguageMap
);
export let lazyGetLocaleOfSupportedLanguageMap = new LazyImport(
    lazyModule,
    m => m.getLocaleOfSupportedLanguageMap
);
export let lazyGetOgmaSupportedLanguageTag = new LazyImport(
    lazyModule,
    m => m.getOgmaSupportedLanguageTag
);
export let lazyGetDetectedLanguage = new LazyImport(lazyModule, m => m.getDetectedLanguage);
export let lazyGetLanguageNameFromTag = new LazyImport(lazyModule, m => m.getLanguageNameFromTag);
export let lazyGetUserLanguageName = new LazyImport(lazyModule, m => m.getUserLanguageName);
export let lazyGetUserLanguageTag = new LazyImport(lazyModule, m => m.getUserLanguageTag);
export let lazyGetTargetLanguageName = new LazyImport(lazyModule, m => m.getTargetLanguageName);
export let lazyGetTargetLanguageTag = new LazyImport(lazyModule, m => m.getTargetLanguageTag);
export let lazyGetTranslationSettings = new LazyImport(lazyModule, m => m.getTranslationSettings);
export let lazyGetIsUserLocaleSupported = new LazyImport(
    lazyModule,
    m => m.getIsUserLocaleSupported
);
export let lazyTranslateText = new LazyImport(lazyModule, m => m.translateText);
export let lazyUpdateTranslationMode = new LazyImport(lazyModule, m => m.updateTranslationMode);
export let lazyUpdateTranslationSettings = new LazyImport(
    lazyModule,
    m => m.updateTranslationSettings
);
